(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire278c"];
var parcelRegister = parcelRequire.register;
parcelRegister("hcNL2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c86a277938d968bc$export$2e2bcd8739ae039);
parcelRequire("je9VQ");
const { slideToggle: $c86a277938d968bc$var$slideToggle } = window.domSlider;
const $c86a277938d968bc$var$siteHeader = document.querySelector(".site-header");
const $c86a277938d968bc$var$hamburger = document.querySelector(".site-header__hamburger");
const $c86a277938d968bc$var$quoteDropdownBtn = document.querySelector(".quote-dropdown .button");
const $c86a277938d968bc$var$initNavigation = ()=>{
    $c86a277938d968bc$var$siteHeader.addEventListener("click", (e)=>{
        const target = e.target;
        /*
    |--------------------------------------------------------------------------
    | Mobile nav and quote dropdown visibility
    |--------------------------------------------------------------------------
    */ if (target === $c86a277938d968bc$var$quoteDropdownBtn || target === $c86a277938d968bc$var$hamburger) {
            let quoteDropdownOpen, mobileNavOpen;
            // Quote dropdown
            if (target === $c86a277938d968bc$var$quoteDropdownBtn) {
                // Close the main menu if it's open
                document.body.classList.remove("menu-open");
                // Toggle visibility of the quote dropdown
                quoteDropdownOpen = document.body.classList.toggle("quote-dropdown-open");
            }
            // Main nav
            if (target === $c86a277938d968bc$var$hamburger) {
                // Close the quote dropdown if it's open
                document.body.classList.remove("quote-dropdown-open");
                // Toggle visibility of the main menu dropdown
                mobileNavOpen = document.body.classList.toggle("menu-open");
            }
            // Add/remove overlay to the body if either of the above are still open
            if (mobileNavOpen || quoteDropdownOpen) document.body.classList.add("show-overlay");
            else document.body.classList.remove("show-overlay");
        }
        /*
    |--------------------------------------------------------------------------
    | Mobile nav - sub-nav dropdowns
    |--------------------------------------------------------------------------
    */ if (target.classList.contains("js-mobile-menu-expand")) {
            const parentMenuItem = target.parentElement;
            const subNavItems = target.nextElementSibling;
            if (!subNavItems || !parentMenuItem) return;
            // Prevent further clicks until complete
            target.classList.add("pointer-events-none");
            // Toggle active on the <li>
            parentMenuItem.classList.toggle("is-active");
            console.log(subNavItems);
            // Reveal the sub-nav
            $c86a277938d968bc$var$slideToggle({
                element: subNavItems,
                slideSpeed: 350,
                easing: "ease-in-out"
            }).then(()=>{
                // Then allow interaction
                target.classList.remove("pointer-events-none");
            });
        }
    });
};
var $c86a277938d968bc$export$2e2bcd8739ae039 = $c86a277938d968bc$var$initNavigation;

});
parcelRegister("je9VQ", function(module, exports) {
"use strict";
(function() {
    "use strict";
    var styleCache = {};
    initDomSlider();
    initPrintStyles();
    function initDomSlider() {
        var sheet = document.createElement("style");
        sheet.id = "dom-slider";
        sheet.innerHTML = "\n      .DOM-slider-hidden {\n        height: 0 !important;\n        padding-top: 0 !important;\n        padding-bottom: 0 !important;\n        border-top-width: 0 !important;\n        border-bottom-width: 0 !important;\n        margin-top: 0 !important;\n        margin-bottom: 0 !important;\n        overflow: hidden !important;\n      }\n    ";
        document.head.appendChild(sheet);
        function slideDown(_ref) {
            var element = _ref.element, slideSpeed = _ref.slideSpeed, easing = _ref.easing, delay = _ref.delay, visibleDisplayValue = _ref.visibleDisplayValue;
            return slide({
                element: element,
                slideSpeed: slideSpeed,
                direction: "down",
                easing: easing,
                delay: delay,
                visibleDisplayValue: visibleDisplayValue
            });
        }
        function slideUp(_ref2) {
            var element = _ref2.element, slideSpeed = _ref2.slideSpeed, easing = _ref2.easing, delay = _ref2.delay;
            return slide({
                element: element,
                slideSpeed: slideSpeed,
                direction: "up",
                easing: easing,
                delay: delay
            });
        }
        function slideToggle(_ref3) {
            var element = _ref3.element, slideSpeed = _ref3.slideSpeed, easing = _ref3.easing, delay = _ref3.delay, visibleDisplayValue = _ref3.visibleDisplayValue;
            return slide({
                element: element,
                slideSpeed: slideSpeed,
                easing: easing,
                delay: delay,
                visibleDisplayValue: visibleDisplayValue
            });
        }
        window.domSlider = {
            slideDown: slideDown,
            slideUp: slideUp,
            slideToggle: slideToggle
        };
    }
    function slide(_ref4) {
        var element = _ref4.element, slideSpeed = _ref4.slideSpeed, direction = _ref4.direction, easing = _ref4.easing, _ref4$delay = _ref4.delay, delay = _ref4$delay === void 0 ? 0 : _ref4$delay, _ref4$visibleDisplayV = _ref4.visibleDisplayValue, visibleDisplayValue = _ref4$visibleDisplayV === void 0 ? "block" : _ref4$visibleDisplayV;
        var domSliderId = element.dataset.domSliderId || (Date.now() * Math.random()).toFixed(0);
        if (!element.dataset.domSliderId) element.dataset.domSliderId = domSliderId;
        if (!styleCache[domSliderId]) styleCache[domSliderId] = {};
        var cachedStyle = styleCache[domSliderId];
        var computedStyle = window.getComputedStyle(element);
        var isDisplayNoneByDefault = computedStyle.getPropertyValue("display") === "none";
        var slideDirection = direction || (isDisplayNoneByDefault || element.classList.contains("DOM-slider-hidden") ? "down" : "up");
        var speed = slideSpeed ? slideSpeed : slideSpeed === 0 ? 0 : 300;
        var boxSizing = computedStyle.getPropertyValue("box-sizing");
        var paddingTop = parseInt(computedStyle.getPropertyValue("padding-top").split("px")[0]);
        var paddingBottom = parseInt(computedStyle.getPropertyValue("padding-bottom").split("px")[0]);
        var contentHeight = Math.max(element.scrollHeight - paddingTop - paddingBottom, 0);
        if (boxSizing === "border-box") contentHeight = Math.max(element.scrollHeight, 0);
        if (element.dataset.sliding) return Promise.resolve(element);
        if (slideDirection === "down" && !isDisplayNoneByDefault && !element.classList.contains("DOM-slider-hidden")) return Promise.resolve(element);
        if (slideDirection === "up" && element.classList.contains("DOM-slider-hidden")) return Promise.resolve(element);
        element.dataset.sliding = true;
        element.setAttribute("aria-hidden", slideDirection === "down" ? "false" : "true");
        if (slideDirection === "down" && isDisplayNoneByDefault) {
            element.classList.add("DOM-slider-hidden");
            element.style.display = visibleDisplayValue;
            contentHeight = element.scrollHeight;
        } // a fixed height is required in order to animate the height
        element.style.height = "".concat(cachedStyle.height ? cachedStyle.height : contentHeight, "px");
        element.style.transition = "all ".concat(speed, "ms ").concat(easing || "");
        element.style.overflow = "hidden";
        return new Promise(function(resolve) {
            setTimeout(function() {
                // begin the animation
                element.classList.toggle("DOM-slider-hidden");
                resolve();
            }, +delay > 20 ? +delay : 20);
        }).then(function() {
            return new Promise(function(resolve) {
                setTimeout(function() {
                    element.style.removeProperty("height");
                    element.style.removeProperty("transition");
                    element.style.removeProperty("overflow");
                    element.removeAttribute("data-sliding");
                    styleCache[domSliderId].height = contentHeight;
                    resolve(element);
                }, speed);
            });
        });
    }
    function initPrintStyles() {
        var hiddenElements;
        function showContent() {
            hiddenElements = document.querySelectorAll(".DOM-slider-hidden");
            hiddenElements.forEach(function(element) {
                element.classList.remove("DOM-slider-hidden");
            });
        }
        function hideContent() {
            hiddenElements.forEach(function(element) {
                element.classList.add("DOM-slider-hidden");
            });
        }
        window.onbeforeprint = showContent;
        window.onafterprint = hideContent;
        var mediaQueryList = window.matchMedia("print");
        mediaQueryList.addListener(function(mql) {
            if (mql.matches) {
                showContent();
                setTimeout(hideContent, 500);
            }
        });
    }
})();

});


})();
//# sourceMappingURL=nav.871beac3.js.map
